import React from "react";
import { connect } from "react-redux";
import AsyncSelect from "react-select/async";
import { search } from "../../../actions/matters";
import { isGuid } from "../../../utils/string";

class MatterSearchListSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: null, // {value,label}
    };

    this._debounceTimer = null;
    this._loadToken = 0;
  }

  componentDidMount() {
    this.hydrateFromValue(this.props.value);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.hydrateFromValue(this.props.value);
    }
  }

  componentWillUnmount() {
    if (this._debounceTimer) clearTimeout(this._debounceTimer);
  }

  toOption = (row) => ({
    value: row.uuid,
    label: `${row.caption ?? ""} ${row.caseNumber ?? ""}`.trim(),
    data: row
  });

  hydrateFromValue = async (value) => {
    const uuid = String(value?.uuid ?? value?.value ?? value ?? "").trim();

    if (!uuid) {
      this.setState({ selectedOption: null });
      return;
    }

    // If parent/backend is feeding something that's not a guid, don't break the UI.
    if (!isGuid(uuid)) return;

    // If we already have it, keep it (prevents flicker/blank)
    if (this.state.selectedOption?.value === uuid) return;

    const token = ++this._loadToken;

    try {
      // If your search endpoint supports uuid lookup, this works.
      const results = await this.props.search({
        search: uuid,
        rows: 1,
        flags: this.props.flags,
      });

      if (token !== this._loadToken) return;

      const row = (results?.items || [])[0];
      const opt = row ? this.toOption(row) : null;

      this.setState({ selectedOption: opt });
    } catch (e) {
      // ignore
    }
  };

  onChange = (opt) => {
    const nextUuid = opt?.value || "";

    // Set option immediately so label never blanks
    this.setState({ selectedOption: opt || null }, () => {
      if (typeof this.props.onChange === "function") {
        this.props.onChange({
          target: { name: this.props.name, value: nextUuid, item: opt },
        });
      }
    });
  };

  loadOptions = (inputValue) => {
    const q = (inputValue || "").trim();
    if (q.length < 2) return Promise.resolve([]);

    return new Promise((resolve) => {
      if (this._debounceTimer) clearTimeout(this._debounceTimer);

      this._debounceTimer = setTimeout(async () => {
        try {
          const results = await this.props.search({
            search: q,
            rows: 100,
            flags: this.props.flags,
          });
          resolve((results?.items || []).map(this.toOption));
        } catch (e) {
          resolve([]);
        }
      }, 250);
    });
  };

  render() {
    return (
      <AsyncSelect
        id={this.props.id ?? this.props.name}
        name={this.props.name}
        className={this.props.className}
        classNamePrefix="react-select"
        placeholder=""
        isClearable={false}
        cacheOptions
        defaultOptions={false}
        loadOptions={this.loadOptions}
        onChange={this.onChange}
        value={this.state.selectedOption}   // <-- label comes from here
      />
    );
  }
}

export default connect(null, { search })(MatterSearchListSelect);
